import { Inject, Injectable } from '@angular/core';
import { ISandboxConfig } from '@lms-approval/onehub-sandbox';
import { SANDBOX_CONFIG } from '../tokens/config.token';

@Injectable()
export class ConfigService {
  constructor(@Inject(SANDBOX_CONFIG) private readonly config: ISandboxConfig) {}

  get apiUrl(): string {
    return this.config.apiUrl;
  }

  get oneHubApiUrl(): string {
    return this.config.apiUrl;
  }

  get production(): boolean {
    return this.config.production;
  }

  get remoteEntryUrl(): string {
    return this.config.remoteEntryUrl;
  }

  get moduleName(): string {
    return this.config.moduleName;
  }

  get uniqueName(): string {
    return this.config.uniqueName;
  }
}
